var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainerTrailerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 205,
    height: 42,
    viewBox: "0 0 205 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeOpacity: 0.87,
    d: "M118.5 2l-10 32",
    transform: "translate(-700 -219) translate(484 142) translate(216 77)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#BCBCBC",
    strokeWidth: 2.222
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M11.257 6.781v24.33M4.503 2.378v33.178M72.047 2.378v33.178M20.263 6.781v24.33M29.269 6.781v24.33M38.275 6.781v24.33M47.28 6.781v24.33M65.292 6.781v24.33M56.287 6.781v24.33",
    transform: "translate(-700 -219) translate(484 142) translate(216 77) translate(127)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.237 1.111H74.31299999999999V36.666999999999994H2.237z",
    transform: "translate(-700 -219) translate(484 142) translate(216 77) translate(127)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M0 37.778h76.55",
    transform: "translate(-700 -219) translate(484 142) translate(216 77) translate(127)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-700 -219) translate(484 142) translate(216 77) translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BCBCBC",
    d: "M76.56 29.794c-1.395-2.87-4.338-4.848-7.743-4.848-3.825 0-7.066 2.496-8.185 5.949H29.011c-.63-3.295-2.443-4.712-6.58-5.052H0V0h99.785v30.895H92.486c-1.118-3.453-4.36-5.949-8.185-5.949-3.405 0-6.348 1.978-7.742 4.848z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.817,
    cy: 33.548,
    r: 4.946,
    stroke: "#BCBCBC",
    strokeWidth: 3.011
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.301,
    cy: 33.548,
    r: 4.946,
    stroke: "#BCBCBC",
    strokeWidth: 3.011
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerTrailerIcon);
export default __webpack_public_path__ + "static/media/container_trailer_icon.1fd10c9146f45bdacb7bf0b1d9655a51.svg";
export { ForwardRef as ReactComponent };